module.exports = __webpack_public_path__ + "static/media/dana.3a7cdf51.jpg";